import { WorkflowStep, WorkflowStepGroup } from "../../../__generated__/api";
import { ACTION } from "./constants";

const sanitizeStep = (step: WorkflowStep): WorkflowStep => {
    const groups = (step.children ?? []) as WorkflowStepGroup[];
    const sanitizedGroups = groups.map(group => ({
        ...group,
        children: (group.children ?? [])
            .filter(child => child.actionId !== ACTION.NEW && child.actionId !== ACTION.GHOST)
            .map(sanitizeStep),
    }));

    return { ...step, children: sanitizedGroups } as WorkflowStep;
};

export default function sanitizeWorkflowSteps(steps?: WorkflowStep[]): WorkflowStep[] {
    if (!steps) {
        return [];
    }

    return steps.map(sanitizeStep);
}
